$(document).ready(function(){
  getInfoVariantFile();
})

function getInfoVariantFile(){
  $.ajax({
    url: 'https://cdn.shopify.com/s/files/1/0660/0468/0937/files/variantColorDefinitiva.csv?v=1668781084',
    dataType: 'text',          
    scriptCharset: "UTF-8",
  }).done(getVariant);
}

function getVariant(data) {
  var allRows = data.split(/\r?\n|\r/);
  var parent = $("#familyParent").val();
  var listaColor = [];
  for (var singleRow = 0; singleRow < allRows.length; singleRow++) {
    var rowCells = allRows[singleRow].split(';');
    if(rowCells[0] != undefined && rowCells[0] != null && rowCells[0] != ""){
      if(rowCells[0].includes(parent)){
        if(!listaColor.includes(rowCells[1])){
          listaColor.push(rowCells[1])
          $(".variant-color").each(function(){
            if($(this).attr("data-color") == rowCells[1]){
              $(this).attr("data-name-color", rowCells[2]);
            }
          })
          // console.log($("#titleVariant").attr("data-color"));
          if($("#titleVariant").attr("data-color") == rowCells[1]){
            $("#titleVariant").attr("data-name-color", rowCells[2]);
            $("#titleVariant span").text(rowCells[2])
          }
        }
      }
    }
  }
}

$(".variant-color").mouseover(function(){
  $("#titleVariant span").text($(this).attr("data-name-color"));
})

$(".container-variant-color").mouseleave(function(){
  $("#titleVariant span").text($("#titleVariant").attr("data-name-color"));
})
